/// <reference path="./Tag.ts" />
namespace HA.Core.HTML {
    //noinspection TsLint
    import HtmlService = HA.Core.HTML.Service.HtmlService;

    export class Img extends Tag {
z
        public updateSrc(src: string): void {
            this.addToData("src", src);
            this.addAttribute("src", src);
        }

        protected initialize(data: any) {
            if (typeof data === "string") {
                data = toMap({src: data});
            }
            if (data.get("src")) {
                data.set("src", this.translate(data.get("src")));
                data.set("_tn", "img");
                super.initialize(data);
                this.addAttribute("data-id", HtmlService.uuidv4());

                this.addAttribute("alt", this.translate(this.get("alt")) || "Image");
                if (this.get("h")) {
                    this.addAttribute("height", this.get("h"));
                }
                if (this.get("w")) {
                    this.addAttribute("width", this.get("w"));
                }
                if (this.has("load")) {
                    this.addAttribute("src", this.get("src"));
                } else {
                    this.addAttribute("data-src", this.get("src"));
                    this.addAttribute("loading", "lazy");
                    lazyloadImage(this.getElement() as HTMLImageElement);
                }
            } else if (data.get("f")) {
                const file = data.get("f");
                const me = this;
                super.initialize(Tag.createElement("img"));
                const reader = new FileReader();
                reader.onload = (e: ProgressEvent) => {
                    me.setAttribute("src", reader.result);
                };
                reader.readAsDataURL(file);
            } else {
                super.initialize(data);
            }
        }
    }
}
